export default "__VITE_ASSET__CoeIySru__"